/** Row count for DATA_GRID / COMPARISON_TABLE — stored as options array length (labels optional). */
export const DATA_GRID_MAX_ROWS = 50;

export function dataGridRowCount(question) {
  const cfg = question?.typeConfig || {};
  if (cfg?.allowAddRows || cfg?.dynamicRows) {
    const d = Number(cfg.defaultRows ?? cfg.minRows ?? 1);
    return Math.max(1, d);
  }
  const cfgCount = Number(cfg.rowCount);
  if (cfgCount && cfgCount > 0) return cfgCount;
  const opts = Array.isArray(question?.options) ? question.options : [];
  if (opts.length) return opts.length;
  return 1;
}

export function buildDataGridOptionsForRowCount(currentOptions, count) {
  const n = Math.min(DATA_GRID_MAX_ROWS, Math.max(1, Number(count) || 1));
  const current = Array.isArray(currentOptions) ? currentOptions : [];
  if (n > current.length) {
    const extra = Array.from({ length: n - current.length }, (_, i) => `Row ${current.length + i + 1}`);
    return [...current, ...extra];
  }
  return current.slice(0, n);
}
